import DSGrid from '../../../design-system/DSGrid';
import CollectionCard from './CollectionCard';
import { useTheme } from '@mui/material';
import useDeviceType from '../../../hooks/useDeviceType';
import DeleteDialog from '../../../components/DeleteDialog';
import useDeleteCollection from '../hooks/useDeleteCollection';
import { useState } from 'react';
import { DELETE_COLLECTION_ALERT } from '../../../consts/alerts';
import { CollectionUnion } from '../../../api/collections';

export type CollectionsGridProps = {
  collections: CollectionUnion[];
};
const CollectionsGrid = ({
  collections: collections,
}: CollectionsGridProps) => {
  const [deletedCollectionId, setDeletedCollectionId] = useState<string>('');
  const { spacing } = useTheme();
  const { isMobile } = useDeviceType();

  const { isDeleting, handleDeleteCollection } = useDeleteCollection(
    deletedCollectionId,
    () => {
      setDeletedCollectionId('');
    },
  );

  return (
    <>
      <DSGrid
        container
        rowGap={{
          xxs: spacing(2),
          xs: spacing(3),
          sm: spacing(3),
          md: spacing(5),
          lg: spacing(8),
          xl: spacing(10),
        }}
        spacing={{
          xxs: spacing(2),
          xs: spacing(3),
          sm: spacing(3),
          md: spacing(5),
          lg: spacing(8),
          xl: spacing(10),
        }}
        columns={{ xs: 1 }}
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xxs: '1fr',
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(3, 1fr)',
            xl: 'repeat(4, 1fr)',
            xxl: 'repeat(5, 1fr)',
          },
        }}
      >
        {collections.map((collection) => (
          <DSGrid key={collection.id}>
            <CollectionCard
              collection={collection}
              isMenuHidden={isMobile}
              handleDeleteCollection={(collectionId) => {
                setDeletedCollectionId(collectionId);
              }}
            />
          </DSGrid>
        ))}
      </DSGrid>
      <DeleteDialog
        deleteMessage={DELETE_COLLECTION_ALERT}
        isDeleteDialogOpen={!!deletedCollectionId}
        handleClose={() => setDeletedCollectionId('')}
        handleConfirmationClick={handleDeleteCollection}
        isDeleting={isDeleting}
      />
    </>
  );
};

export default CollectionsGrid;
